import CustomAxios from "..";

export const updatePlanTagById = async (id, planTag) => {
  try {
    const response = await CustomAxios.put(`/plans/id/${id}`, {
      planTag,
    });
    return response.data;
  } catch (error) {
    console.error("Error updating plan:", error.message || error);
    throw new Error("Failed to update the plan. Please try again.");
  }
};

export const updateSinglePlanTagById = async (id, planTag) => {
  try {
    const response = await CustomAxios.put(`/plans/workoutId/${id}`, {
      planTag,
    });
    return response.data;
  } catch (error) {
    console.error("Error updating plan:", error.message || error);
    throw new Error("Failed to update the plan. Please try again.");
  }
};
export const updateRecipieTagById = async (id, recipeTag) => {
  try {
    const response = await CustomAxios.put(`/recipe/id/${id}`, {
      recipeTag,
    });
    return response.data;
  } catch (error) {
    console.error(
      `Error fetching plans with tag "${recipeTag}":`,
      error.response?.data || error.message
    );
    throw new Error("Failed to retrieve the plans by tag. Please try again.");
  }
};
